(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exports(
            require('./search.js'),
            require('./name.js'),
            require('../../enums/metrics.js'),
            require('lodash'),
            require('backbone.marionette')
        );

    } else {
        RivalIQ.metric.render = exports(
            RivalIQ.metric.search,
            RivalIQ.metric.names,
            RivalIQ.enums,
            window._,
            window.Marionette
        );
    }

    function exports(searchFn, nameFn, metricEnums, _, Marionette) {

        function description(metric, options) {
            options = _.defaults(options || {}, {
                name: true,
                dimensions: ['channel']
            });

            if (_.isArray(metric)) {
                return _.compact(_.map(metric, function (m) {
                    return description(m, options);
                })).join('<hr>');
            }

            let copy = metric;
            const descriptionDimensions = options.descriptionDimensions;
            if (_.isArray(descriptionDimensions)) {
                copy = _.defaults({
                    dimensions: descriptionDimensions
                }, metric);
            }

            const desc = copy.description || searchFn.getPropertyValue(copy, 'description');

            if (!desc) {
                return;
            }

            const details = [];
            // NOTE only show time analysis mode description if we are not in the default (main period, i.e. TAM 0) mode
            if (copy.timeAnalysisMode && !options.omitTimeAnalysisModeDescription) {
                details.push(metricEnums.timeAnalysisMode.descriptions[metric.timeAnalysisMode]);
            }

            return Marionette.TemplateCache.get('#metricDescription')({
                name: (options.name ? nameFn.metricName(copy, options) : undefined),
                description: desc,
                details: details
            });
        }

        return {
            description: description
        };
    }
})();
